import { createGlassHttp } from "@crystal/glass-bridge";
import { PermissionToDocumentMap } from "../types/index.js";
const filterByType = (doc, type) => doc.configuration.acceptanceMechanism === type;
const sortByOrder = (doc1, doc2) => doc1.configuration.displayOrder - doc2.configuration.displayOrder;
const mapScenario = (scenarioName, documents) => {
  const docs = documents == null ? void 0 : documents.sort(sortByOrder);
  return {
    scenarioName,
    explicitDocuments: docs == null ? void 0 : docs.filter((d) => filterByType(d, "Explicit")),
    implicitDocuments: docs == null ? void 0 : docs.filter((d) => filterByType(d, "Implicit"))
  };
};
const mapConsentPayload = (scenario, acceptanceLocale) => {
  const { scenarioName, implicitDocuments, explicitDocuments } = scenario;
  const implicitConsents = implicitDocuments.map(({ document }) => ({
    documentName: document.documentName,
    accepted: true
  }));
  const explicitConsents = explicitDocuments.map(({ document, configuration }) => ({
    documentName: document.documentName,
    accepted: configuration.accepted ?? configuration.acceptancePreSelected
  }));
  return {
    legalAcceptance: {
      scenarioName,
      acceptanceLocale,
      acceptances: [...implicitConsents, ...explicitConsents]
    }
  };
};
const getScenario = (config) => async (scenarioType, source = "40", fields = []) => {
  const api = createGlassHttp();
  const { sitePath, locale } = config;
  const { scenarioName = "", documents } = await api.get(
    `/api/permissions/scenarios/${locale}/${scenarioType}`,
    {
      query: {
        scenarioType,
        source,
        fields: fields.join(),
        ...sitePath ? { sitePath } : {}
      }
    }
  );
  return mapScenario(scenarioName, documents);
};
const hasInvalidConsents = ({ explicitDocuments }) => explicitDocuments.some((d) => d.configuration.acceptanceRequired && !d.configuration.accepted);
const patchPermission = async (doc, consentsState) => {
  const {
    document: { documentName },
    configuration: { accepted }
  } = doc;
  const scenarioType = accepted ? "account-optin" : "account-optout";
  const { acceptances, scenarioName } = consentsState[scenarioType].payload.legalAcceptance;
  const t = [
    PermissionToDocumentMap.MARKETING_SMS,
    PermissionToDocumentMap.NEWSLETTER,
    PermissionToDocumentMap.PAID_MEDIA,
    PermissionToDocumentMap.DATA_PROCESSING
  ].find((p) => documentName.includes(p));
  const patchedAcceptances = acceptances.filter((a) => a.documentName.includes(t));
  patchedAcceptances[0] = { ...patchedAcceptances[0], accepted: true };
  const payload = {
    scenarioName,
    acceptances: patchedAcceptances
  };
  try {
    const api = createGlassHttp();
    return await api.patch(`/api/permissions/update-permissions`, payload);
  } catch (_e) {
    return [];
  }
};
const requestDoiConfirmation = async () => {
  try {
    const api = createGlassHttp();
    return await api.post("/api/account/profile/request-doi-confirmation");
  } catch (e) {
    return null;
  }
};
export {
  getScenario,
  hasInvalidConsents,
  mapConsentPayload,
  mapScenario,
  patchPermission,
  requestDoiConfirmation
};
//# sourceMappingURL=index.js.map
